<template>
  <div class="privacy">
    <p class="text-bold">发布日期： 2024 年 07 月 19 日</p>
    <p class="text-bold">生效日期： {{ policyEffectiveTime }}</p>
    <br>
    <p>本政策适用于极兔速递有限公司及其子公司、直属分支机构、加盟合作伙伴等（以下简称“极兔”或“我们”）。我们一直非常重视用户的隐私和个人信息保护，您在使用我们的产品与/或服务时，我们可能会收集和使用您的相关个人信息。我们将会通过本隐私政策向您说明我们在提供产品与/或服务时如何收集、存储、使用、共享、转让、公开披露这些信息，以及我们为您提供的访问、更新、删除和保护这些信息的方式。<span class="text-bold_line">如果您对本隐私政策有任何疑问、意见或建议，可通过极兔在线客服或电子邮件、客服电话等方式与我们联系，一般情况下，我们将在十五个工作日内回复。</span></p>
    <p class="paragraph">我们的地址：上海市青浦区华新镇华隆路1777号；</p>
    <p class="paragraph">官方网站地址：<a class="link" href="https://www.jtexpress.cn" target="_">https://www.jtexpress.cn</a>；</p>
    <p class="paragraph">邮件：<a class="link">jtservice@jtexpress.com</a>；</p>
    <p class="paragraph">客服电话：<span class="text-bold">956025</span></p>
    <p class="paragraph">如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以通过以下外部途径寻求解决方案，向您所在国家的监管部门进行投诉或举报，例如中国的网信、电信、公安及工商等监管部门。</p>
    <p class="paragraph">本隐私政策与您所使用的极兔物流服务以及该服务所包括的各种业务功能（以下统称“我们的产品与/或服务”）息息相关，请务必仔细阅读并理解本政策。一旦您开始使用或在我们更新本隐私政策后继续使用我们的产品与/或服务，即表示您已充分理解并同意本政策(含更新版本)内容，并且同意我们按照本政策的约定处理您的个人信息。如您不同意本政策的任何条款，您应立即停止使用极兔的产品与/或服务。</p>
    <p class="paragraph">当您同意隐私协议后仍然可以通过以下途径再次浏览:</p>
    <div class="paragraph">
      <p class="paragraph-2">1. 访问官网点击底部<span class="text-bold">“隐私政策”；</span></p>
      <p class="paragraph-2">2. 小程序中通过<span class="text-bold">“我的”-“隐私政策”。</span></p>
    </div>

    <p>本政策将帮助您了解以下内容：</p>
    <p class="text-bold">一、我们如何收集和使用您的个人信息</p>
    <p class="text-bold">二、我们如何使用Cookie和同类技术</p>
    <p class="text-bold">三、我们如何对外提供、转移、公开披露您的个人信息</p>
    <p class="text-bold">四、我们如何保护和保存您的个人信息</p>
    <p class="text-bold">五、您的权利</p>
    <p class="text-bold">六、您的个人信息如何在全球范围转移</p>
    <p class="text-bold">七、第三方SDK功能说明</p>
    <p class="text-bold">八、我们如何处理儿童的信息</p>
    <p class="text-bold">九、本政策如何更新及争议解决</p>
    <p class="text-bold">十、如何联系我们</p>
    <br>
    <p class="text-bold">一、我们如何收集和使用您的个人信息</p>
    <p>我们的业务包括了基本业务功能和扩展业务功能，我们仅会出于下述目的，收集和使用您的个人信息：</p>
    <p>（一）为实现基本业务功能，收集和使用您个人信息的情形</p>
    <p>我们可能会收集、保存和使用您有关的信息才能实现下述功能。如果您不提供相关信息，您将无法享受相关的服务。这些功能包括：</p>
    <p>1.寄递用户注册及实名制</p>
    <p>我们将小程序作为寄递用户注册入口。您在小程序中可以选择输入手机号注册或登录，也可以通过微信、淘宝等小程序运营方授权进行快捷登录。当您选择前者时，我们将收集您的手机号码；当您选择后者快捷登录时，您可以通过点击授权我们使用微信、淘宝等小程序运营方的用户注册信息。</p>
    <p>根据《邮件快件实名收寄管理办法》、《常见类型移动互联网应用程序必要个人信息范围规定》及监管部门其他文件要求，您同意我们收集您的<span class="text-bold_line">寄件人姓名、证件类型和号码等身份信息</span>作为实名登记信息。实名制的信息我们将上报至国家实名收寄信息监管平台。</p>
    <p>2.为您提供物流服务</p>
    <p>在您下单寄件或您的信息作为收件人被提供时，我们收集以下信息：<span class="text-bold_line">寄件人及收件人的姓名、地址、联系方式和货件信息</span>（统称“运单信息”），用于提交订单、生成物流运单、收件、分拣、以及派送货件；根据相关法律要求，我们还收集<span class="text-bold_line">您的身份证件信息</span><span class="text-bold_line">用于核验您的身份。若您不同意我们收集前述信息，将无法使用物流服务，也无法完成对您身份的核验。</span></p>
    <p><span class="text-bold_line">如果您提供了不准确或错误的地址，在不违反相关法律法规对个人信息存储的强制要求的前提下，我们可能会使用您过往的运单信息对不准确、错误的地址信息进行补全、纠正，以节省与收/寄件人反复确认地址的时间，</span>保证时效，避免您因快件错误派送、延迟派送而遭受损失，让您有更好的服务体验。</p>
    <p>3.优惠促销活动</p>
    <p>您可以选择参与极兔的促销活动，享受订单金额减免、领取赠品等优惠。为实现前述优惠，我们还需要收集与处理您的<span class="text-bold_line">Union ID、Open ID、微信账号、淘宝账号等关联账号信息、模糊地理位置信息</span>等信息数据。</p>
    <p>4.支付结算</p>
    <p>在您下单后，您可以选择我们的关联方或合作的第三方支付机构（如支付宝、微信支付以及银联、网联等支付通道，以下称“支付机构”）所提供的支付服务，我们需要将您的订单号与交易金额信息提供给这些支付机构以确认您的支付指令并完成支付。</p>
    <p>如您为企业用户，在申请发票时需提供以下信息：<span class="text-bold_line">发票抬头、纳税人识别号、纳税人电子邮箱、手机号；</span>如您为个人/事业单位，则需要提供以下信息：<span class="text-bold_line">抬头姓名、电子邮箱、手机号。</span></p>
    <p>5.消息推送</p>
    <p>我们使用微信公众号、小程序向您推送快件路由信息、支付状态信息、促销优惠活动及其他消息通知信息，为了完成消息推送功能将收集您的设备型号和操作系统及版本。您可以在设备的“设置”或在微信公众号、小程序进行免打扰设置。</p>
    <p>6.版本管理及更新</p>
    <p>在您使用极兔速递提供的服务时，我们需要收集您的<span class="text-bold_line">MAC、Android ID、UUID信息。</span>若您不同意我们收集前述信息，将无法及时进行版本更新，影响您的使用。</p>
    <p>7.<span class="text-bold_line">账号信息和运单信息</span></p>
    <p><span class="text-bold_line">我们的客服和售后功能会使用您的账号信息和运单信息。</span></p>
    <p>为保证您的账号安全，我们的在线客服会使用您的账号信息、运单信息核验您的身份。当您需要我们提供与您的寄件相关的客服与售后服务时，我们将会查询您的运单信息、货件路由信息。</p>
    <p>您有可能在与我们的客服人员沟通时，提供上述信息外的其他信息，如当您要求我们变更派送地址、联系人或联系电话。</p>
    <p>8.保障交易安全</p>
    <p>为提高您使用我们的服务时系统的安全性，保护您或其他用户或公众的人身财产安全免遭侵害，更准确地预防钓鱼网站欺诈和保护账户安全，<span class="text-bold_line">我们可能会通过了解您的浏览信息、运单信息、您常用的软件信息、设备信息来判断您的账号风险，并可能会记录一些我们认为有风险的链接（“URL”）；我们也会收集您的设备信息（IMEI、MEID、IMSI设备标识符）、设备所在位置相关信息（IP地址）、应用信息（app版本、应用崩溃信息、通知开关状态、软件列表相关信息）、设备参数及系统信息（设备类型、设备型号、操作系统及硬件相关信息）和微信ID（针对从微信端使用极兔服务的用户）对于极兔系统问题进行分析、统计流量并排查可能存在的风险、在您选择向我们发送异常信息时予以排查。</span>若您不同意我们收集前述信息，我们将无法保证您的交易安全。</p>
    <p>9.安全风控的需要</p>
    <p>当您浏览、使用小程序时，我们会向您收集您的<span class="text-bold_line">OpenID、UnionID、相关设备信息（包括设备品牌、设备型号、操作系统信息）、微信相关信息（包括微信设置的语言、微信版本号）</span>进行分析、统计流量并排查可能存在的风险、保护账户安全、协助异常事件的排查。 </p>
    <p>（二）扩展业务功能收集和使用您个人信息的情形</p>
    <p>1）网点查询功能</p>
    <p>为了方便您查询我们的服务网点，并使用导航功能，您可以在小程序中授权开启地理位置权限，我们将收集您的<span class="text-bold_line">地理位置信息。</span></p>
    <p>2）地址快填功能</p>
    <p>为了方便您快速填写地址，在小程序中除手动输入外，我们还提供了通过定位功能导入及通过OCR对身份证识别导入的方式。</p>
    <p>a.在使用定位功能导入时需要您授权开启地理位置权限，我们将收集您的<span class="text-bold_line">地理位置信息。</span></p>
    <p>b.在使用OCR对身份证识别导入时需要您授权摄像头权限及相册读取权限，我们不会因此收集您任何信息。</p>
    <p>3）扫码寄件功能</p>
    <p>为了简化您的寄件过程，我们在小程序中还提供扫描寄件功能，在使用该功能时需要您授权摄像头权限及相册读取权限。</p>
    <p>为实现基本业务功能和扩展业务功能，我们基于不同目的所需要收集和处理的个人信息类型如下所列：</p>
    <el-table :data="personalInfoTypeData" border>
      <el-table-column label="处理目的" prop="purpose" align="center"></el-table-column>
      <el-table-column label="个人信息类型" prop="infoType" align="center"></el-table-column>
      <el-table-column label="敏感个人信息字段" prop="sensitiveFields" align="center"></el-table-column>
    </el-table>
    
    <p>（三）设备权限信息的收集和使用</p>
    <el-table :data="devicePermissionsData" border>
      <el-table-column label="设备权限" prop="devicePermissions" align="center"></el-table-column>
      <el-table-column label="对应业务功能" prop="corresponding" align="center"></el-table-column>
      <el-table-column label="功能场景说明" prop="description" align="center"></el-table-column>
      <el-table-column label="是否可以关闭" prop="canClose" align="center"></el-table-column>
    </el-table>

    <p>（四）我们从第三方获得您个人信息的情形</p>
    <p>1）在您同意本政策后我们会通过小程序授权获取您的手机号码，将小程序与我们的账户绑定，这时您可以通过小程序直接登录并使用我们的服务。同样在获得您授权后还会从小程序方共享您的头像、昵称。</p>
    <p>2）在通过第三方渠道下单寄件时，例如电商平台、快递物流服务受理组织等，收寄人姓名、地址、电话和货件等面单信息由该第三方收集并打印在我们提供的空白模板上。相关数据信息（收寄件人姓名、地址、货件信息及脱敏后的电话）根据合同约定及个人信息保护策略，通过API接口传递给我们，以完成对您的收寄件相关服务。</p>
    <p>3）如我们从我们的合作伙伴获取您的个人信息，我们将依据与第三方的约定，在符合相关法律和法规规定的前提下，使用您的这些个人信息。</p>
    <p>我们承诺：</p>
    <p>1）我们从第三方间接获取您的个人信息的数量为实现产品业务功能所必需的最少数量。</p>
    <p>2）从第三方间接获取您的个人信息时，要求第三方说明个人信息来源，并会对其个人信息来源的合法性进行确认。我们将了解并审慎注意第三方已获得您的个人信息处理的授权同意范围包括使用目的，您是否授权同意转让、共享、公开披露等。我们开展业务所需进行的个人信息处理活动超出该授权同意范围的，将在获取您的个人信息后的合理期限内或处理您的个人信息前，征得您的明示同意。</p>
    <p>（五）其他用途</p>
    <p>当我们要将您的个人信息用于本政策未载明的其它用途时，或将基于特定目的收集而来的信息用于其他目的时，会通过在线点击授权或邮件、短信形式事先征求您的明确同意。</p>
    <p>（六）征得同意的例外</p>
    <p>您充分知悉，<span class="text-bold_line">在以下情形中，我们收集、使用个人信息无须征得您的授权同意：</span></p>
    <p>1.与国家安全、国防安全有关的；</p>
    <p>2.与公共安全、公共卫生、重大公共利益有关的；</p>
    <p>3.与犯罪侦查、起诉、审判和判决执行等有关的；</p>
    <p>4.出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
    <p>5.所收集的个人信息是个人信息主体自行向社会公众公开的；</p>
    <p>6.从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；</p>
    <p>7.根据您的要求签订和履行合同所必需的；</p>
    <p>8.用于维护所提供的服务的安全稳定运行所必需的，例如发现、处置服务的故障；</p>
    <p>9.为合法的新闻报道所必需的；</p>
    <p>10.法律法规规定的其他情形。</p>


    <p class="text-bold">二、我们如何使用Cookie和同类技术</p>
    <p class="text-bold">1.Cookie</p>
    <p>为确保网站正常运转，我们会在您的计算机或移动设备上存储名为Cookie的小数据文件。Cookie通常包含标识符、站点名称以及一些号码和字符。借助于Cookie，网站能够存储您的偏好等数据。</p>
    <p><span class="text-bold_line">我们不会将Cookie用于本政策所述目的之外的任何用途。</span>您可根据自己的偏好管理或删除 Cookie。有关详情，请参见AboutCookies.org。您可以清除计算机上保存的所有Cookie，大部分网络浏览器都设有阻止Cookie的功能。但如果您这么做，则需要在每一次访问我们的网站时亲自更改用户设置。如需详细了解如何更改浏览器设置，请访问您使用的浏览器的相关设置页面。</p>
    <p class="text-bold">2.Do Not Track（请勿追踪）</p>
    <p>很多网络浏览器均设有Do Not Track功能，该功能可向网站发布Do Not Track请求。目前，主要互联网标准组织尚未设立相关政策来规定网站应如何应对此类请求。但如果您的浏览器启用了Do Not Track，那么我们的所有网站都会尊重您的选择。</p>


    <p class="text-bold">三、我们如何对外提供、转移、公开披露您的个人信息</p>
    <p>（一）对外提供</p>
    <p>1.向授权合作伙伴提供：</p>
    <p>仅为实现本政策中声明的目的，我们的某些服务将由授权合作伙伴提供。我们可能会向合作伙伴提供您的某些个人信息，以提供更好的客户服务和用户体验。我们只会提供服务所必要的个人信息，我们将会按照法律的规定向您披露。我们会与授权合作伙伴依法签署数据处理协议，要求他们按照本政策的要求以及采取其他必要的保密和安全措施来处理个人信息，授权合作伙伴变更原先的处理目的、处理方式的，应当重新取得您的同意。我们的合作伙伴无权将接收的个人信息用于任何其他用途，除非另行获得您的单独同意。</p>
    <p>目前，我们的授权合作伙伴包括以下类型：</p>
    <p>供应商、服务提供商和其他合作伙伴。我们将信息发送给在全球范围内支持我们业务的供应商、服务提供商和其他合作伙伴，这些支持包括提供技术基础设施服务、分析我们服务的使用方式或潜在风险、运输、仓储、清关、末端收派、支付便利、提供客户服务、提供数据存储或数据分析服务、提供第三方附加业务功能服务（如语音输入、地图功能）或进行学术研究和调查。</p>
    <p>2.向我们的关联公司提供</p>
    <p>您的个人信息可能会向极兔的关联公司提供。我们只会提供必要的最小化个人信息，且受本政策中所声明目的的约束。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意。</p>
    <p>我们承诺对您的信息进行严格保密，仅会出于合法、正当、必要、特定、明确的目的共享您的用户信息，并且只会共享提供服务所必要的用户信息，除法律法规及监管部门另有规定外。在共享您的个人信息前，我们会进行个人信息安全影响评估。</p>
    <p>同时我们会与上述供应商、服务提供商和其他合作伙伴的个人信息安全防护能力水平提出要求，签署严格的承诺书/保密协议/数据处理协议，要求他们按照我们的说明、本政策以及其他任何相关的保密和安全措施来处理个人信息。一旦发现违反协议约定将会采取有效措施甚至终止合作。</p>
    <p><span class="text-bold_line">鉴于我们的合作方可能会基于业务实际需要而不时更换，如您在使用过程中希望确认数据接收方的最新情形或对我们使用的第三方服务和供应商有任何疑问，您可通过本政策中提供的联系方式与我们取得联系，我们会及时响应您的请求、解答您的疑惑。</span></p>
    <p>（二）转移</p>
    <p>我们不会将您的个人信息转移给任何公司、组织和个人，但以下情况除外：</p>
    <p>1.在符合相关法律法规及网信部门规定的条件下，根据您的指示，按照我们提供的转移途径将您的个人信息转移至您指定的接收方；</p>
    <p>2.如因我们的有关业务/资产转让、重组、处置（包括资产证券化）、合并、分立、收购或解散、被宣告破产等原因需要转移您的个人信息的，我们将向您告知接收方的名称或者姓名和联系方式，我们会要求该接收方继续接受本隐私权政策规定的约束，否则我们将要求该接收方重新向您获得同意。</p>
    <p>（三）公开披露</p>
    <p>我们仅会在以下情况下，公开披露您的个人信息：</p>
    <p>1.获得您明确同意或基于您的主动选择，我们可能会公开披露您的个人信息；</p>
    <p>2.如果我们确定您出现违反法律法规或严重违反极兔相关协议规则的情况，或为保护极兔用户或公众的人身财产安全免遭侵害，我们可能依据法律法规或极兔相关协议规则征得您同意的情况下披露关于您的个人信息，包括相关违规行为以及极兔已对您采取的措施。</p>
    <p>3.基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。</p>
    

    <p class="text-bold">四、我们如何保护和保存您的个人信息</p>
    <p>（一）我们如何保护您的个人信息安全</p>
    <p>1.我们设立了数据安全管理职能，采取个人信息在物理（门禁隔离、监控系统）、管理（制定信息安全体系制度、将数据分类分级、与员工签订保密协议、开展数据安全和隐私保护培训、定期开展合规自评估）和技术（通过https安全浏览方式确保传输加密、采用加密技术确保数据存储加密、敏感信息内容展示脱敏、匿名化处理、系统访问部署了双因素认证访问控制机制、自动化代码检查、日志审计）等方面的安全保障措施努力保护您的个人信息不被未经授权地访问、使用、披露、修改、损坏或丢失及其它的形式的非法处理。</p>
    <p>2.我们会定期组织安全应急预案演练，防止安全事件发生。若不幸发生极兔知悉所获取并储存的数据安全受到危害时，或由于外部行为（例如黑客攻击）使用户的非公开信息被披露给不相关第三方时，尽管本政策中有其他免责规定，极兔也会启动应急预案，组成紧急应急小组，启动流程，进行内部调查、上报并通知监管部门、以及配合监管部门工作，降低事故对用户的影响，同时会在认为适当的情况下采取推送通知、邮件、公告等形式告知相关用户，告知其被披露的信息以及极兔对该等情况的知悉程度。</p>
    <p>（二）个人信息的保存期限</p>
    <p>1. 我们仅会在为达成本指引所述目的所需<span class="text-bold_line">最短期限</span>内保留个人信息，除非法律有强制的存留要求。</p>
    <p>2. 如果我们终止服务或运营，我们会至少<span class="text-bold_line">提前三十日</span>向您通知，并在终止服务或运营后对您的个人信息进行删除或匿名化处理；超出必要期限后，我们也将对您的个人信息进行删除或匿名化处理，但法律法规另有规定的除外。</p>


    <p class="text-bold">五、您的权利</p>
    <p>按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利：</p>
    <p>（一）访问您的个人信息</p>
    <p>1） 账户信息</p>
    <p>如果您希望访问您的账户中的个人资料信息，您可以使用账号和密码或通过第三方授权，登录我们的小程序在“个人设置”中查看绑定的手机号码，通过“我的”-“实名登记”中查看其他信息。这些信息我们将脱敏展示。</p>
    <p>2）寄件记录和交易记录</p>
    <p>您可以使用账号和密码或通过第三方授权，登录我们的小程序在“查件”中查询。</p>
    <p>3）寄件、收件信息</p>
    <p>您可以使用账号和密码或通过第三方授权，登录我们的小程序在“我的”-“地址”中查询或新增寄件人和收件人的姓名、手机号码、寄递件地址。</p>
    <p>如您需要访问您在使用我们的产品与/或服务过程中产生的其他个人信息，您可以通过本隐私政策所列明的联系方式与我们联系，我们会在<span class="text-bold_line">十五个工作日</span>内响应您的请求。</p>
    <p>（二）更正或补充您的个人信息</p>
    <p>当您发现我们处理的关于您的个人信息有错误时，您有权要求我们做出更正或补充。</p>
    <p>您可以通过“（一）访问您的个人信息”中罗列的方式更正您的个人信息。如您需要更正或补充您在使用我们的产品或服务过程中产生的其他个人信息，您也可以与我们的客服联系。</p>
    <p>（三）删除您的个人信息</p>
    <p>1.您可以在以下情形中，向我们提出删除个人信息的请求：</p>
    <p>1）如果我们处理个人信息的行为违反法律法规；</p>
    <p>2）如果我们收集、使用您的个人信息，却未征得您的同意；</p>
    <p>3）如果我们处理个人信息的行为违反了与您的约定；</p>
    <p>4）如果您不再使用我们的产品与/或服务，或您注销了账号；</p>
    <p>5）如果我们不再为您提供产品与/或服务。</p>
    <p>也可以通过“（一）访问您的个人信息”中罗列的方式删除您的实名制信息、寄递记录、寄递人信息。在满足法律法规的要求的前提下，我们将响应您的请求，对个人信息进行完全删除。</p>
    <p>2.当您或我们协助您从我们的服务中删除信息后，因为适用的法律和安全技术，我们可能无法立即备份系统中删除相应的信息，我们将安全地存储您的个人信息并将其与任何进一步处理隔离，直到备份可以清除或实现匿名。</p>
    <p>3.若我们决定响应您的删除请求，我们还将同时尽可能通知从我们处获得您的个人信息的主体，并要求其及时删除（除非法律法规另有规定，或这些主体已独立获得您的授权）。</p>
    <p>（四）获取个人信息副本</p>
    <p>如您需要您的个人信息副本，您可以通过极兔在线客服或电子邮件、客服电话等方式与我们联系，向我们提出相应请求。在通过必要的验证措施后，我们将在法律法规允许的情况下，按照本政策所列明的方式和期限处理您的请求并将您的个人信息发送您至指定的邮箱。</p>
    <p>（五）改变您授权同意的范围</p>
    <p>每个业务功能需要一些基本的个人信息才能得以完成（见本政策第一部分）。对于其他（见本政策“（二）扩展业务功能收集和使用您个人信息的情形”）个人信息的收集和使用，您可以随时给予或收回您的授权同意。您可以通过关闭系统权限的方式来撤回您原来的授权，但请您注意，此项撤回不影响我们之前通过您的授权所收集的个人信息，同时，因您的某些授权是实现我们某些业务功能的必要权限，您撤回相应授权的可能会影响您使用我们对应的部分业务功能。</p>
    <p>1）您可以通过小程序“设置”-“订阅消息”拒绝接收通知；“设置”-“位置信息”选择“不允许”或“仅在使用小程序期间”；</p>
    <p>2）还可以通过小程序 “设置”-“已获取的信息”，通过“管理”通知我们在24小时内删除“选中的照片或视频”及“手机号”。</p>
    <p>另外您也可以通过注销账号的方式，撤回我们继续收集您个人信息的全部授权。</p>
    <p>3）当您收回同意后，我们将不再处理相应的个人信息。但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。</p>
    <p>4）当您收到我们发送的短信时，可以根据信息中的退订提示（如“回复TD退订”），要求不再向您发送短信，我们会尊重您的请求。您可以通过“我的”-“反馈与投诉”向我们提出相应请求，在通过必要的验证措施后，我们将本政策所列明的方式和期限处理您的请求。您也可以通过注销账户的方式，撤回我们继续收集您个人信息的全部授权。</p>
    <p><span class="text-bold">当您收回同意后，我们将不再处理相应的个人信息。但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。</span></p>
    <p>（六）个人信息主体注销账户</p>
    <p>您可以通过登录小程序，根据“我的”-“注销账号”路径提交注销账户的请求。我们会提供注销协议，告知您执行注销操作可能造成的影响，当您继续选择注销我们的账户时，我们将对您的权益及信息设置<span class="text-bold_line">十五天</span>的注销删除等待期，在提交注销申请后的等待期内可撤销申请，并可通过重新注册复原相关个人账号信息和相关个人服务记录，超过等待期将根据法律法规删除或匿名化处理。</p>
    <p>（七）响应您的上述请求</p>
    <p>1.为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。</p>
    <p>2.您的请求我们将在<span class="text-bold_line">十五个工作日</span>内做出答复。如您对我们的答复不满意，还可以通过本政策所述的联系方式向我们投诉。</p>
    <p>3.对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。</p>
    <p>4.在以下情形中，按照法律法规要求，我们将无法响应您的请求：</p>
    <p>（1）与个人信息处理者履行法律法规规定的义务相关的；</p>
    <p>（2）与国家安全、国防安全直接相关的；</p>
    <p>（3）与公共安全、公共卫生、重大公共利益直接相关的；</p>
    <p>（4）与刑事侦查、起诉、审判和执行判决等直接相关的；</p>
    <p>（5）个人信息处理者有充分证据表明个人信息主体存在主观恶意或滥用权利的；</p>
    <p>（6）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
    <p>（7）响应您的请求将导致个人信息主体或其他个人、组织的合法权益受到严重损害的；</p>
    <p>（8）涉及商业秘密的。</p>



    <p class="text-bold">六、您的个人信息如何在全球范围转移</p>
    <p>原则上，我们在中华人民共和国境内运营中收集和产生的个人信息，将存储在中华人民共和国境内。</p>
    <p>如您选择我们的国际件服务，我们会通过将国际件运单信息传输给您使用产品或服务所在国家/地区的境外管辖区，或者受到来自这些管辖区的访问。此外，为实现本政策所声明的其他目的，您的个人信息亦可能被传输到您使用产品或服务所在国家/地区的境外管辖区。</p>
    <p>此类管辖区可能设有不同的数据保护法，甚至未设立相关法律。在此类情况下，我们会确保您的个人信息得到在原始收集国/地区境内足够同等的保护。例如，运单信息采取加密传输、定期评估审计接收方的安全能力水平、签订数据处理协议/条款。</p>



    <p class="text-bold">七、第三方SDK功能说明</p>
    <p>合作的第三方SDK服务商:当您使用极兔由第三方提供的功能时，我们可能会接入由第三方提供的软件开发包( SDK )以实现相关功能。此时，第三方SDK服务商可能会收集您相关的个人信息。前述服务商收集和处理信息等行为遵守其自身的隐私条款，而不适用于本政策。为了最大程度保障您的信息安全，我们建议您在使用任何第三方SDK类服务前先行查看其隐私条款。为保障您的合法权益，如您发现此等SDK或其他类似的应用程序存在风险时，建议您立即终止相关操作并及时与我们取得联系。</p>
    <p>（一）第三方账号登录功能：为给您提供第三方账号登录的功能，第三方服务商可能会获取您的必要设备信息、网络相关信息、地理位置信息;</p>
    <p>（二）消息推送服务：为给您提供消息推送，第三方推送服务商可能会获取您的推送SDK版本号、必要设备信息、手机状态信息、地理位置信息、网络相关信息以便推送系统相关通知；</p>
    <p>（三）支付服务：为保障您顺利购买平台上的商品/服务、虚拟商品，第三方支付服务商可能会收集您的设备信息网络信息、运营商信息以实现顺利完成支付以及保证支付安全。</p>
    <p>（四）云储存服务：为给您提供云端储存服务，第三方服务商可能会收集您的设备信息、网络相关信息运营商信息。</p>
    <p>具体请查阅：《第三方信息共享清单》</p>
    


    <p class="text-bold">八、我们如何处理儿童的个人信息</p>
    <p>（一）我们非常重视对儿童个人信息的保护。若您是14周岁以下的儿童，在使用我们的产品或服务前，应事先请您的监护人阅读本政策并征得您监护人的同意。</p>
    <p>（二）我们不会主动直接向儿童收集个人信息。对于经监护人同意而收集儿童个人信息的情况，我们只会在受到法律允许、监护人同意或者保护儿童所必要的情况下使用、共享、转让或披露此信息。</p>
    <p>（三）如有事实证明儿童并未取得监护人同意的情况下注册使用了我们的产品或服务，我们会与监护人协商，并设法尽快删除相关个人信息。</p>
    <p>（四）对于可能涉及的不满14周岁的儿童个人信息，我们进一步采取以下措施予以保障：</p>
    <p>1.对于收集到的儿童个人信息，我们除遵守本隐私政策关于用户个人信息的约定外，还会秉持正当必要、知情同意、目的明确、安全保障、依法利用的原则，严格遵循《儿童个人信息网络保护规定》等法律法规的要求进行存储、使用、披露，且不会超过实现收集、使用目的所必须的期限，到期后我们会对儿童个人信息进行删除或匿名化处理。</p>
    <p>2.当您作为监护人为被监护的儿童选择使用极兔产品或服务时，我们可能需要向您收集被监护的儿童个人信息，用于向您履行相关服务之必要。在具体服务中需要向您收集儿童个人信息的，我们会事先取得您的授权同意，并告知您收集的目的和用途。如果您不提供前述信息，您将无法享受我们提供的相关服务。若儿童本人需要注册或使用我们的产品与/或服务，您应正确引导并予以监护。</p>
    <p>3.儿童或其监护人有权随时访问和更正儿童个人信息，还可以向我们提出更正和删除的请求。如您对儿童个人信息相关事宜有任何意见、建议或投诉、举报，请联系我们。我们会随时为您提供帮助。</p>
    


    <p class="text-bold">九、本政策如何更新及争议解决</p>
    <p>（一）未经您明确同意，我们不会削减您按照本政策所应享有的权利。我们会在本页面上发布对本政策所做的任何变更。</p>
    <p>（二）对于重大变更，我们还会提供更为显著的通知（包括对于某些服务，我们会通过弹窗发送通知，说明隐私政策的具体变更内容）。</p>
    <p>（三）本政策所指的重大变更包括但不限于：</p>
    <p>1.我们的服务模式发生重大变化。如处理个人信息的目的、处理个人信息的类型以及个人信息的使用方式等；</p>
    <p>2.我们在控制权、组织架构等方面发生重大变化。如并购重组等引起的控制者变更等；</p>
    <p>3.个人信息共享、转让或公开披露的主要对象发生变化；</p>
    <p>4.您参与个人信息处理方面的权利及其行使方式发生重大变化；</p>
    <p>5.我们负责处理用户信息安全的责任部门、联络方式及投诉渠道发生变化时；</p>
    <p>6.用户信息安全影响评估报告表明存在高风险时。</p>
    <p>（四）本政策的执行、解释及争议的解决均适用中华人民共和国法律，且不考虑任何冲突法。</p>
    <p>（五）您和我们就本政策内容或其执行发生任何争议的，双方应友好协商解决；如双方无法协商解决争议时，您可以向公安、监管部门（网信办等）或权威部门投诉、举报，或者依据适用的法律向具有管辖权的法院提起诉讼。</p>



    <p class="text-bold">十、如何联系我们</p>
    <p>（一）我们设置了专门的信息安全部门保护您的个人信息，如有相关问题可通过下列方式反馈或投诉举报。我们将在<span class="text-bold_line">十五个工作日</span>向您反馈。</p>
    <p>a)通过热线电话956025或者“在线客服”与我们联系，客服会将相关事项转交给个人信息保护责任部门处理；</p>
    <p>b)数据安全负责人：王先生</p>
    <p>隐私保护邮箱：privacy@jtexpress.com</p>
    <p>或者寄信到上海市青浦区华新镇华隆路1777号A座9楼 信息安全部门（收）邮编：201705。</p>
    <p>（二）我们的信息</p>
    <p>我们的地址：上海市青浦区华新镇华隆路1777号；</p>
    <p>官方网站地址：https://www.jtexpress.cn；</p>
    <p>邮件：jtservice@jtexpress.com；</p>
    <p>客服电话：956025</p>
    <p>附件：《第三方信息共享清单》</p>

    <p class="text-center">第三方共享个人信息清单</p>
    <p class="indent">在我们向您提供服务时，我们会采取严格的安全措施。当您使用极兔由第三方提供的功能时，我们可能会接入由第三方提供的软件开发包（ SDK ）以实现相关功能。此时，第三方SDK服务商可能会收集您相关的个人信息。为了更好地为您提供服务，我们可能会与其他合作商等第三方共享或委托处理您的部分个人信息。</p>
    <p>（一）第三方账号登录功能：为给您提供第三方账号登录的功能，第三方服务商可能会获取您的必要设备信息、网络相关信息、地理位置信息；</p>
    <p>（二）消息推送服务：为给您提供消息推送，第三方推送服务商可能会获取您的推送SDK版本号、必要设备信息、手机状态信息、地理位置信息、网络相关信息、个人手机号码、订单号、订单信息以便推送系统相关通知；</p>
    <p>（三）支付服务：为保障您顺利购买平台上的商品/服务、虚拟商品，第三方支付服务商可能会收集您的设备信息网络信息、运营商信息以实现顺利完成支付以及保证支付安全。</p>
    <p>（四）云储存服务：为给您提供云端储存服务，第三方服务商可能会收集您的设备信息、网络相关信息和运营商信息。</p>
    <el-table :data="sdkData" border>
      <el-table-column label="" type="index"></el-table-column>
      <el-table-column label="名称" prop="sdkName"></el-table-column>
      <el-table-column label="主体" prop="SDKbody"></el-table-column>
      <el-table-column label="使用信息" prop="SDKusageInfo"></el-table-column>
      <el-table-column label="信息使用目的" prop="purpose"></el-table-column>
      <el-table-column label="信息使用场景" prop="scenarios"></el-table-column>
      <el-table-column label="信息传输方式" prop="transmission"></el-table-column>
      <el-table-column label="第三方隐私政策" prop="link"></el-table-column>
    </el-table>
    <p></p>
    <p></p>
    <br />
  </div>
</template>

<script>
import { policyEffectiveTime } from '@/constants'
export default {
  name: 'PrivacyPolicy',
  data() {
    return {
      policyEffectiveTime: '',
      personalInfoTypeData: [
        { purpose: '注册账号', infoType: '个人基本资料', sensitiveFields: '无' },
        { purpose: '第三方登录', infoType: '网络身份标识信息', sensitiveFields: '无' },
        { purpose: '寄递实名制要求', infoType: '个人基本资料、个人身份信息', sensitiveFields: '身份证信息' },
        { purpose: '物流服务', infoType: '个人基本资料、个人身份信息、运单信息', sensitiveFields: '身份证信息' },
        { purpose: '完善寄件信息', infoType: '个人基本资料、地理位置信息', sensitiveFields: '地理位置信息' },
        { purpose: '查询服务点', infoType: '地理位置信息', sensitiveFields: '地理位置信息' },
        { purpose: '支付结算', infoType: '个人基本资料、个人财产信息', sensitiveFields: '无' },
        { purpose: '服务消息推送', infoType: '个人常用设备信息', sensitiveFields: '无' },
        { purpose: '客服与售后', infoType: '个人基本资料、网络身份标识信息、运单信息、个人通信信息', sensitiveFields: '无' },
        { purpose: '保障交易安全', infoType: '个人基本资料、个人上网记录、网络身份标识信息、个人常用设备信息、设备所在位置相关信息、运单信息', sensitiveFields: '无' },
        { purpose: '识别分析', infoType: '个人基本资料、个人身份信息、个人财产信息、个人上网记录、网络身份标识信息、个人常用设备信息、运单信息', sensitiveFields: '身份证信息' },
        { purpose: '个性化推荐及广告信息推送', infoType: '个人基本信息、个人常用设备信息', sensitiveFields: '无' },
        { purpose: '便捷下单', infoType: '剪切板信息、地理位置信息、通讯录信息', sensitiveFields: '无' }
      ],
      devicePermissionsData: [
        { devicePermissions: '麦克风', corresponding: '便捷下单', description: '开启语音输入单号信息时，进行录音', canClose: '可以，关闭后仅影响对应功能，不影响其他功能' },
        { devicePermissions: '通讯录', corresponding: '便捷下单', description: '方便您再填写运单信息时不再手动输入通讯录中联系人的信息', canClose: '可以，关闭后仅影响对应功能，不影响其他功能' },
        { devicePermissions: '地理位置', corresponding: `查询服务点；便捷下单`, description: '获取服务点的准确位置信息并使用导航功能，获取当前位置信息帮助用户输入寄件地址，方便用户填写运单中的地址信息', canClose: '可以，关闭后仅影响对应功能，不影响其他功能' },
        { devicePermissions: '相机/摄像头权限', corresponding: '扫码快递单号；拍摄快递照片', description: '扫描识别单号信息提升用户操作速度；拍照上传用于问题件快递的举证；上传寄递物品照片', canClose: '可以，关闭后仅影响对应功能，不影响其他功能' },
        { devicePermissions: '存储权限', corresponding: '缓存必要信息', description: '保障极兔速递APP运行稳定，承诺仅读取或存储必要的信息', canClose: '可以，关闭后仅影响对应功能，不影响其他功能' },
        { devicePermissions: '相册', corresponding: '识别、上传照片', description: '识别图片地址、上传寄托物品照片', canClose: '可以，关闭后仅影响对应功能，不影响其他功能' },
        { devicePermissions: '通知权限', corresponding: '系统通知', description: '相关消息推送', canClose: '可以，关闭后仅影响对应功能，不影响其他功能' },
        { devicePermissions: '网络权限', corresponding: '核心业务功能', description: '数据上传与查看', canClose: '可以，关闭后无法正常使用相关服务' },
        { devicePermissions: '电话权限', corresponding: '网络电话', description: '拨打网络电话', canClose: '可以，关闭后仅影响对应功能，不影响其他功能' },
        { devicePermissions: '蓝牙', corresponding: '连接蓝牙打印机', description: '连接蓝牙打印机，打印面单', canClose: '可以，关闭后仅影响对应功能，不影响其他功能' },
        { devicePermissions: '剪切板', corresponding: '便捷下单', description: '读取、识别剪切板中的内容，用于智能填写收寄件人、联系电话及地址信息', canClose: '可以，关闭后仅影响对应功能，不影响其他功能' }
      ],
      sdkData: [
        { sdkName: '移动统计', SDKbody: '友盟同欣', SDKusageInfo: '设备信息、网络信息', purpose: '推送消息、数据统计', scenarios: '初始化SDK后', transmission: '初始化SDK后，App基础数据上报', link: 'https://www.umeng.com/page/policy' },
        { sdkName: '腾讯云SDK', SDKbody: '腾讯云', SDKusageInfo: '身份证信息', purpose: '实名验证', scenarios: '图片识别', transmission: '/', link: 'https://cloud.tencent.com/document/product/301/11470' },
        { sdkName: '百度智能云SDK', SDKbody: '百度智能云', SDKusageInfo: '地理位置信息', purpose: '填写地址', scenarios: '图片识别', transmission: '/', link: 'https://cloud.baidu.com/doc/Agreements/s/Plr0fi68q' },
        { sdkName: '支付宝APP', SDKbody: '支付宝（中国）网络技术有限公司', SDKusageInfo: '订单号、订单信息（运单号、运单状态、物流轨迹）、收件人手机号', purpose: '为用户提供消息推送功能', scenarios: '消息推送时', transmission: '后台接口传输', link: 'https://render.alipay.com/p/c/180020570000000579/index.html' }
      ]
    }
  },
  components: {

  },
  methods: {
    dayjs(value) {
      if (value) {
        const date = new Date(value)
        const yyyy = date.getFullYear()
        const MM = date.getMonth() + 1
        const DD = date.getDate()
        return `${yyyy} 年 ${MM > 9 ? MM : '0' + MM} 月 ${DD > 9 ? DD : '0' + DD} 日`
      }
      return ''
    },
  },
  mounted() {
    this.policyEffectiveTime = this.dayjs(policyEffectiveTime)
  }
}
</script>

<style lang="scss">
.privacy {
  .el-table th, .el-table td {
    padding: 4px 0;
  }
}
</style>

<style lang="scss" rel="text/css" scoped>
  .privacy{
    background-color: #ffffff;
    font-size: 1em;
    font-weight: 400;
    padding: 20px 30px;
    line-height: 2em;
    .title{
      text-align: center;
      font-size: 2em;
      font-weight: bold;
      margin-bottom: 1em;
    }
    .title-sub{
      font-weight:bold;
      font-size: 1.5em;
      text-align: center;
    }
    .indent{
      text-indent: 2em;
    }
    .text-bold{
      font-weight:bold;
      &_line {
        font-weight:bold;
        text-decoration: underline;
        
      }
    }
    .text-center {
      text-align: center;
    }
    .bg-yellow{
      background-color: rgb(241, 221, 41);
    }
    .paragraph {
      text-indent: 2em;
      &-2 {
        text-indent: 4em;
      }
    }
    .link {
      text-decoration: underline;
      color: #00a0e9;
      &:hover {
        text-decoration: none;
      }
    }
  }
</style>
